<div class="dropdown-with-title">
  <label class="dropdown-with-title-label">{{config.title}}</label>
  <!-- options -->
  <select deep-blur id="dropdownWithTitle_select" class="form-control selection"
          [formControl]="selectControl">
    <option [ngValue]="null">- Not Selected -</option>
    <option *ngFor="let option of config.options; trackBy: trackByFn"
            [ngValue]="option">{{option.option}}
    </option>
  </select>

  <!--<gen-invalid-tooltip class="invalid-tooltip-wrapper"-->
  <!--[tooltipPlacement]="'right'"-->
  <!--[tooltipRequired]="config.signAsRequired"-->
  <!--[tooltipText]="config.tooltip + ' is invalid'"></gen-invalid-tooltip>-->

</div>
